import { DatasetRepository } from '../repositories/DatasetRepository';

export class DatasetService {
  private repository: DatasetRepository;

  constructor() {
    this.repository = DatasetRepository.getInstance();
  }

  /**
   * Get all datasets
   */
  public async getAllDatasets(): Promise<any[]> {
    return await this.repository.getAllDatasets();
  }

  /**
   * Create a new dataset
   */
  public async createDataset(formData: FormData): Promise<any> {
    return await this.repository.createDataset(formData);
  }

  /**
   * Update a dataset
   */
  public async updateDataset(id: string, payload: any): Promise<any> {
    return await this.repository.updateDataset(id, payload);
  }

  /**
   * Get dataset by ID
   */
  public async getDatasetById(id: string): Promise<any> {
    return await this.repository.getDatasetById(id);
  }

  /**
   * Delete a dataset
   */
  public async deleteDataset(id: string): Promise<void> {
    return await this.repository.deleteDataset(id);
  }

  /**
   * Get dataset template by type
   */
  public async getDatasetTemplate(type: 'single' | 'multi-turn'): Promise<any> {
    return await this.repository.getDatasetTemplate(type);
  }
}

// Export singleton instance
export const datasetService = new DatasetService();
